<template>
  <div class="custom-order">
    <Breadcrumb></Breadcrumb>

    <!-- 过滤条件 -->
    <div class="form-body">
      <el-form :model="form" ref="form" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="设计编号：" class="item">
                <el-input
                  v-model="form.beforeDesignId"
                  class="input"
                  size="small"
                  clearable
                />
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="转换设计编号：" class="item">
                <el-input
                  v-model="form.afterDesignId"
                  class="input"
                  size="small"
                  clearable
                />
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple">
              <el-form-item label="创建时间：" class="item">
                <el-date-picker
                  type="daterange"
                  placeholder="选择日期"
                  v-model="form.createTime"
                  class="input"
                  size="small"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="item right">
              <el-button type="primary" size="small" @click="getData(1)"
                >搜索</el-button
              >
              <el-button type="default" size="small" @click="reset"
                >重置</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 表格 -->
    <div class="table-body">
      <div class="top">
        <div class="left"></div>
        <div class="right">
          <pagination
            :total="total"
            :page.sync="form.pageNum"
            :limit.sync="form.pageSize"
            @pagination="getData"
          />
        </div>
      </div>
      <el-table id="myOrder" ref="table" :data="tableData" class="table">
        <el-table-column width="457px" align="center" label="定制产品">
          <template slot-scope="scope">
            <div class="table-info-wrap">
              <div class="table-detail">
                <div class="left">
                  <img
                    class="mini-img limit"
                    :src="
                      scope.row.beforePicUrl ? scope.row.beforePicUrl : noImage
                    "
                    slot="reference"
                  />
                </div>
                <div class="left" style="padding: 15px 0 0 0;width: 300px;">
                  <div :title="scope.row.beforeProName" class="text-ellipsis">
                    产品名称：
                    <b
                      @click="handleOpenDesignPage(scope.row.beforeDesignId)"
                      style="color:#409eff;cursor:pointer;"
                      >{{ scope.row.beforeProName || "--" }}</b
                    >
                  </div>
                  <div
                    :title="scope.row.beforeProperVal"
                    class="text-ellipsis"
                    v-if="scope.row.beforeProperName"
                  >
                    <span
                      v-if="
                        scope.row.beforeProperName && scope.row.beforeProperVal
                      "
                    >
                      <span
                        v-for="(i, ind) in [0, 1]"
                        :key="'i_' + ind"
                        style="margin-right: 10px;"
                      >
                        {{ scope.row.beforeProperName.split(":")[i] }}：
                        {{ scope.row.beforeProperVal.split(":")[i] }}
                      </span>
                    </span>
                  </div>
                  <div>
                    设计编号：
                    {{ scope.row.beforeDesignId || "-" }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="457px" align="center" label="转换定制产品">
          <template slot-scope="scope">
            <div class="table-info-wrap">
              <div class="table-detail">
                <div class="left">
                  <img
                    class="mini-img limit"
                    :src="
                      scope.row.afterPicUrl ? scope.row.afterPicUrl : noImage
                    "
                    slot="reference"
                  />
                </div>
                <div class="left" style="padding: 15px 0 0 0;width: 300px;">
                  <div :title="scope.row.afterProName" class="text-ellipsis">
                    产品名称：
                    <b
                      @click="handleOpenDesignPage(scope.row.afterDesignId)"
                      style="color:#409eff;cursor:pointer;"
                      >{{ scope.row.afterProName || "--" }}</b
                    >
                  </div>
                  <div
                    :title="scope.row.afterProperVal"
                    class="text-ellipsis"
                    v-if="scope.row.afterProperName"
                  >
                    <span
                      v-if="
                        scope.row.afterProperName && scope.row.afterProperVal
                      "
                    >
                      <span
                        v-for="(i, ind) in [0, 1]"
                        :key="'i_' + ind"
                        style="margin-right: 10px;"
                      >
                        {{ scope.row.afterProperName.split(":")[i] }}：
                        {{ scope.row.afterProperVal.split(":")[i] }}
                      </span>
                    </span>
                  </div>
                  <div>
                    设计编号：
                    {{ scope.row.afterDesignId || "-" }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作人"
          align="center"
          prop="nickName"
          width="120"
        >
         <template slot-scope="scope">
            {{ scope.row.nickName ?  scope.row.nickName : scope.row.operNo}}
          </template>
        </el-table-column>
        <el-table-column align="center" label="创建时间" width="200">
          <template slot-scope="scope">
            <div class="loan-wrap">
              <div>
                {{ scope.row.createTime }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <div class="operate" @click="modifyFn(scope.row)">
              修改
            </div>
            <div class="operate" @click="deleteFn(scope.row)">
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="getData"
      />
    </div>
      <!-- 复制弹窗 -->
    <TransformOrder
      v-if="currentOrder"
      :visible="showTransform"
      @onClose="hideTransform"
      :order="currentOrder"
      @onOk="okTransformOrder"
    />
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import { mapGetters } from "vuex"
import dayjs from "dayjs"
import { listChange, deleteChange } from "@/api/order/all"
import noImage from "@/assets/images/no_image.png"
import TransformOrder from "./components/TransformOrder"

export default {
  name: "relatedOrder",
  components: {
    Breadcrumb,
    TransformOrder
  },
  data() {
    return {
      form: {
        beforeDesignId: "",
        afterDesignId: "",
        createTime: [], // 创建时间
        pageNum: 1,
        pageSize: 10,
      },
      modalTitle: "",
      modalText: "",
      statusText: "",
      statusMap: null,
      total: 0,
      tableData: [], // 表格数据
      currentOrder: {},
      currentAppId: "",
      noImage: noImage,
      showTransform: false
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  mounted() {
    this.getData()
  },
  methods: {
    // 搜索
    getData() {
      let params = Object.assign({}, this.form)

      if (this.form.createTime && this.form.createTime.length > 0) {
        params["beginTime"] = dayjs(this.form.createTime[0]).format(
          "YYYY-MM-DD"
        )
        params["endTime"] = dayjs(this.form.createTime[1]).format("YYYY-MM-DD")
      }

      delete params["createTime"]

      listChange(params).then((res) => {
        if (res.code !== 200) {
          this.$message.error("获取订单列表失败")
        } else {
          this.total = res.total
          this.tableData = res.rows
        }
      })
    },
    // 重置
    reset() {
      this.form = {
        beforeDesignId: "",
        afterDesignId: "",
      }
    },
    deleteFn(data) {
      this.$confirm("是否确认删除已定制产品？", "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteChange(data.id).then((res) => {
          if (res.code !== 200) {
            this.$message.error("删除失败")
          } else {
            this.getData()
            this.$message({
              type: "success",
              message: "删除成功!",
            })
          }
        })
      })
    },
    modifyFn(order) {
      this.showTransform = true
      this.currentOrder = order
    },
    handleOpenDesignPage(id) {
      let routeUrl = this.$router.resolve({
        path: "/select/custom/product",
        query: { designId: id },
      })
      window.open(routeUrl.href, "_blank")
    },
    hideTransform(){
      this.showTransform = false
    },
    okTransformOrder(){
      this.showTransform = false
      this.getData()
    }
  },
}
</script>

<style scoped>
.form-body {
  padding: 10px 20px;
}

.form-body .item {
}
.form-body .item.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table-body {
  margin-top: 10px;
  border: 1px solid #ebeef5;
  background: #fff;
  font-size: 12px;
  overflow: hidden;
}

.table-body /deep/.el-table .cell {
  padding: 0;
}

.table-body .top {
  padding: 0 0 8px 0;
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding-right: 0;
}

.table-body > .table {
  margin-bottom: 10px;
}

.table-info-wrap {
  margin-bottom: -10px;
}

.table-info {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 10px;
  padding: 0 10px;
  font-size: 12px;
}

.loan-wrap {
  display: flex;
  flex-direction: column;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  font-size: 12px;
  text-align: center;
}

.loan-wrap .title.lw40 {
  width: 24px;
}

.loan-wrap .title {
  width: 48px;
  display: inline-block;
  text-align: justify;
  text-align-last: justify;
}

.operate {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 12px;
  color: #1e7ec8;
  cursor: pointer;
}
.limit {
  width: 100px;
  margin: 0 8px 0 0;
}
.table-detail {
  padding: 0 16px;
  text-align: left;
}
</style>
